const { Component, render, findDOMNode, Fragment, useState, useEffect } = wp.element;
const { __ } = wp.i18n

const alias = 'wtop-brands-';

const WTopDisplayBrands = ({ settings }) => {

  const [ brands, setBrands ] = useState(WTopBrands.brands);
  const [ brandsToBeShowed, setBrandsToBeShowed ] = useState([]);
  const [ currentCategory, setCurrentCategory ] = useState(settings.categories_to_be_showed[0]);
  const originalBrands = WTopBrands.brands;
  const numberOfCategories = settings.number_of_categories;

  useEffect(() => {
    setCurrentCategory(settings.categories_to_be_showed[0]);
  }, [settings.categories_to_be_showed[0]]);

  useEffect(() => {
    console.log(`Filter - ${currentCategory}`);
    let result;
    if(currentCategory == 'All') {
      result = originalBrands;
    } else {
      result = Object.keys( originalBrands ).filter( key => originalBrands[key].brand_category == currentCategory).map(val => {
        return originalBrands[val];
      });
    }
    setBrands(result);
  }, [currentCategory]);

  const buildHeader = () => {

    const categories = settings.categories_to_be_showed.includes('All') ? WTopBrands.categories : settings.categories_to_be_showed;
    return <ul className={`${alias}categories`}>

      <li style={{ borderColor: settings.border_color_brands, color: settings.text_color_brands }} onClick={ () => {
        setBrands(originalBrands);
        setCurrentCategory("All");
      }}>Shop by Brand</li>

      { settings.categories_to_be_showed.includes('All') ? <li onClick={ () => {
        setBrands(originalBrands);
        setCurrentCategory("All");
      }}><a 
          style={{ 
            borderColor: settings.border_color_brands,
            borderTopColor: currentCategory == 'All' ? settings.border_color_category : settings.border_color_brands, 
            color: currentCategory == 'All' ? settings.border_color_category : settings.text_color_brands
          }} 
          className={`${alias}category ${currentCategory == 'All' ? `is_active`: ``}` }
        >All Categories</a></li> : "" }

      { categories.map( ( categ, index ) => index < numberOfCategories ? <li key={ index }>
          <a 
            style={{ 
              borderColor: settings.border_color_brands,
              borderTopColor: currentCategory == categ ? settings.border_color_category : settings.border_color_brands,
              color: currentCategory == categ ? settings.border_color_category : settings.text_color_brands
            }} 
            className={`${alias}category ${currentCategory == categ ? `is_active`: ``}` } 
            onClick={(e) => {
              e.preventDefault();
              setCurrentCategory(categ);
            }}
          >{ categ }</a>
        </li> : "" ) }

      { categories.length > numberOfCategories ? <li onClick={() => {
        setCurrentCategory("more");
      }}><a 
        style={{ 
          borderColor: settings.border_color_brands,
          borderTopColor: currentCategory == 'more' ? settings.border_color_category : settings.border_color_brands,
          color: currentCategory == 'more' ? settings.border_color_category : settings.text_color_brands
        }} 
        className={`${alias}category ${currentCategory == 'more' ? `is_active`: ``}` }
      >More Categories</a></li> : "" }

    </ul>
  }

  const buildBrands = () => {
    const categories = settings.categories_to_be_showed.includes('All') ? WTopBrands.categories : settings.categories_to_be_showed;

    if( currentCategory != 'more' ) {
      if(Object.keys( brands ).length == 0 ) return <p>{ __('No Brands in this category', 'wtop-brands') }</p>
      
      return <ul className={`${alias}brands`} style={{gridTemplateColumns: `repeat(${settings.number_of_items}, 1fr)`}}>
        { Object.keys( brands ).map( ( key, index ) => {
          let number_of_cols = Object.keys( brands ).length / settings.number_of_items;
          let floor_number_of_cols = Math.floor(number_of_cols);
          if(number_of_cols == floor_number_of_cols) {
            floor_number_of_cols--;
          }
          if(brands[key].brand_image_url != null ) {
            return <li key={ index } style={{
              borderRight: (index + 1) % ( settings.number_of_items  ) != 0 ? `1px solid ${settings.border_color_brands}` : '',
              borderBottom: index < floor_number_of_cols * settings.number_of_items ? `1px solid ${settings.border_color_brands}` : '',

            }}><a href={ brands[key].brand_url } className={`${alias}brand`}><img src={ brands[key].brand_image_url } /></a></li>
          }
          
        }) }
      </ul>
    } else {
      return <ul className={`${alias}categories-list`}>
        { categories.map((categ, index) => {
          let number_of_cols = Object.keys( categories ).length / 3;
          let floor_number_of_cols = Math.floor(number_of_cols);
          if(number_of_cols == floor_number_of_cols) {
            floor_number_of_cols--;
          }
          return <li
            style={{
              borderRight: (index + 1) % 3 != 0 ? `1px solid ${settings.border_color_brands}` : '',
              borderBottom: index < floor_number_of_cols * 3 ? `1px solid ${settings.border_color_brands}` : '',
            }}
            onClick={() => {
              setCurrentCategory(categ);
            }}
          ><a style={{ color:settings.border_color_category }}> { categ } </a></li>})}
      </ul>
    }
    
  }

  return <div style={{ backgroundColor: settings.background_brands }}>
      { buildHeader() }
      { buildBrands() }

      <style dangerouslySetInnerHTML={{__html: `
        .${alias}category:hover {
          color: ${ settings.border_color_category } !important;
        }
      `}}
      />
    </div>
}

export { WTopDisplayBrands };



// WEBPACK FOOTER //
// ./src/DisplayBrands.js